import React from 'react';
import './Student360.css';

// One yellow bar for every course; green only once the course is finished, an empty track at zero.
function toneOf(percent) {
  if (percent >= 100) return 'is-done';
  if (percent > 0) return 'is-some';
  return 'is-zero';
}

/** A whole-number progress bar with its value; `label` names it for screen readers. */
function ProgressBar({ value, label, showValue = true }) {
  const percent = Math.min(100, Math.max(0, Math.round(Number(value) || 0)));
  return (
    <div
      className="s360-progress"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
      aria-label={label}
    >
      <div className="s360-bar">
        <div className={`s360-bar-fill ${toneOf(percent)}`} style={{ width: `${percent}%` }} />
      </div>
      {showValue && <span className="s360-bar-val">{percent}%</span>}
    </div>
  );
}

export default ProgressBar;
